document.addEventListener('DOMContentLoaded', function () {
    const swiperEl = document.querySelector('.retailers-swiper');
    if (swiperEl) {
        new Swiper(swiperEl, {
            slidesPerView: 2.5,
            spaceBetween: 15,
            grabCursor: true,
            breakpoints: {
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 30
                },
                992: {
                    slidesPerView: 3.5,
                    spaceBetween: 40
                }
            }
        });
    }
});
